(function ($) {
  Drupal.behaviors.productCrossSellsV1 = {
    attach: function (context, settings) {
      var p_index = 0;

      if (page_data['catalog-spp-workswith']) {
        for (var www_pid in page_data['catalog-spp-workswith'].products) {
          var undef;
          var has_valid_sku = false;
          var product = page_data['catalog-spp-workswith'].products[www_pid];

          // iterate thru skus to make sure at least one is shoppable
          $(product.skus).each(function (i, sku) {
            var o_sku = $(document).data(sku.SKU_ID);

            has_valid_sku = true; // yes, let's include this product
          });

          if (has_valid_sku) {
            product.classtags = '';
            // stop at 5 items
            if (p_index > 4) {
              continue;
            } else if (p_index > 2) {
              // mark items 4 and 5 so they can hidden for responsiveness
              product.classtags += ' end_items';
            }
            var www_item = Drupal.cl.template.get({
              path: 'goes_with',
              object: product,
              callback: function (html) {
                return html;
              }
            });

            $('.product-full__cross-sell__panel.goes_with:first', context).append(www_item);
            p_index++;
          }
        }
      }
    }
  };
})(jQuery);
